





























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class FieldTextRange extends Vue {
    @Prop({type: String}) public text!: string;
    @Prop({type: Number}) public startIndex!: number;
    @Prop({type: Number}) public endIndex!: number;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;
    @Prop({type: Boolean, default: false}) public isStressMaker?: boolean;

    private errorSelect: boolean = false;
    private selecting: boolean = false;
    private firstIndex?: number = undefined;

     public mounted() {
        window.addEventListener('mouseup', this.charMouseUp);
    }

    public charMouseUp() {
        this.selecting = false;
    }


    public setSelection(startIndex: number, endIndex: number) {
        if (startIndex > endIndex) {
            const tmp = startIndex;
            startIndex = endIndex;
            endIndex = tmp;
        }


        this.$emit('update:startIndex', startIndex);
        this.$emit('update:endIndex', endIndex);

        let tmpTextSelected = '';
        for (let index = startIndex; index <= endIndex; index++) {
            if (this.text[index]){
                tmpTextSelected += this.text[index].replace(/\s/g, '');
            }
        }

        if (tmpTextSelected === ''){
            this.errorSelect = true;
        }else{
             this.errorSelect = false;
        }

        if(this.isStressMaker){
            this.$emit('change-word', true);
        }
    }

    public containerMouseDown() {
        if (!this.selecting) {
            this.setSelection(-1, -1);
        }
    }

    public charMouseDown(index: number) {
        if (!this.disabled) {
            this.selecting = true;
            this.firstIndex = index;
            this.setSelection(index, index);
        }
    }

    public charMouseEnter(index: number) {
        if (!this.disabled && this.selecting) {
            this.setSelection(this.firstIndex, index);
        }
    }
}
